import React, { useContext, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { ResumePopupContext } from "../../Context/resumePopupContext";
import ResumeSubUseForm from "../../hooks/editor/resumeSubUseForm";
import { useDispatch, useSelector } from "react-redux";

function DeletePopup(props) {
  const {
    showPopup,
    setShowPopup,
    setShowDeletePopup,
    showDeletePopup,
    sectionId,
    setSectionId,
    arrayIndex,
    setArrayIndex,
    customIndex,
  } = useContext(ResumePopupContext);

  const editorData = useSelector((state) => state.editorLoading);
  const spinnerStyle = {
    maxWidth: "15px",
    position: "absolute",
    top: "50%",
    transform: "translate(23%, -54%)",
  };
  const [rand, setRand] = useState("");
  const { handleSectionDelete, handleDelete } = ResumeSubUseForm(sectionId);

  const hidePopup = () => {
    setShowDeletePopup(false);
  };

  const [loading, setLoading] = useState(false);

  const sectionLoader = () => {
    if (showDeletePopup) {
      setLoading(true);
      setRand(1);
    } else {
      setLoading(false);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      if (rand && rand != "") {
        setLoading(false);
        setShowDeletePopup(false);
      }
    }, 1000);
    setRand("");
  }, [editorData]);

  return (
    <>
      <Modal
        show={showDeletePopup}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <button type="button" className="close" onClick={hidePopup}>
            <span aria-hidden="true">
              <img
                src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
                alt="closeicon"
                className="close_popup"
              />
            </span>
            <span className="sr-only">Close</span>
          </button>
          <div className="container">
            <div className="text-center">
              <h4 className="maintitle">Delete Section</h4>
              <p className="titledesc">
                Are you sure you want to Delete this Section?
                <br />
                Once Deleted this Section cannot be Restored.
              </p>
            </div>
            <div className="row mt-4">
              <div className="col-md-6 col-sm-12 col-12">
                <button
                  className="btn primarybtn  float-right p-14 w-75"
                  style={{ lineHeight: "24px" }}
                  onClick={hidePopup}
                >
                  Cancel
                </button>
              </div>

              <div className="col-md-6 col-sm-12 col-12">
                <button
                  className="btn primarybtn successbtn   w-75 mainborder"
                  onClick={() => {
                    props.handleSectionDelete(customIndex);
                    sectionLoader();
                  }}
                >
                  {loading && loading ? (
                    <>
                      <span className="resume-options">Deleting...</span>
                      <img
                        src="/images/loadwhite.gif"
                        style={spinnerStyle}
                        alt="loading"
                      />
                    </>
                  ) : (
                    <span className="resume-options">Delete</span>
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DeletePopup;
